import { render, staticRenderFns } from "./edit-system-prompt.vue?vue&type=template&id=00fec9ba&scoped=true"
import script from "./edit-system-prompt.vue?vue&type=script&lang=js"
export * from "./edit-system-prompt.vue?vue&type=script&lang=js"
import style0 from "./edit-system-prompt.vue?vue&type=style&index=0&id=00fec9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fec9ba",
  null
  
)

export default component.exports